module.exports = __webpack_public_path__ + "static/media/backpython.cf8f2caf.jpg";